import { render } from "./secondaryButtonDark.vue?vue&type=template&id=cf5d2554"
import script from "./secondaryButtonDark.vue?vue&type=script&lang=js"
export * from "./secondaryButtonDark.vue?vue&type=script&lang=js"

import "./secondaryButtonDark.vue?vue&type=style&index=0&id=cf5d2554&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__